import React from "react";
import moment from 'moment'


const Datetime = (props) => {

    const dateFormatted = moment(props.children).format('DD-MM-YYYY')

    return (
        <div>
            {dateFormatted}
        </div>
    )
}

export default Datetime;